import styled from "@emotion/styled";

export const TextArea = styled.textarea`
  padding: 0.5rem;
  font-size: 1rem;
  margin-bottom: 0.5rem;
  width: 100%;
  border-radius: var(--mi-border-radius);
  color: var(--mi-text-color);
  background-color: var(--mi-background-color);
  border: 1px solid var(--mi-text-color);
`;

export default TextArea;
